import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import SingleStats from "./Components/SingleStats/SingleStats";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import NewsAPI from "../../api/NewsApi";

const Stats = () => {
  const { id } = useParams(); 
  const [statsData, setStatsData] = useState(null); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchStatsData = async () => {
      try {
        setLoading(true);
        const response = await NewsAPI.getStatsData(id); // جلب البيانات باستخدام id
        setStatsData(response.data); // تخزين البيانات في state
      } catch (err) {
        console.error(err);
        setError("حدث خطأ أثناء تحميل البيانات.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchStatsData(); // استدعاء الدالة لجلب البيانات
    }
  }, [id]);

  if (loading) {
    return <p>جاري تحميل البيانات...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!statsData) {
    return <p>لا توجد بيانات لعرضها.</p>;
  }


  return (
    <>
       <HelmetInfo titlePage={"انجاز فى ارقام"} />
<div className="mt-[150px]"/>
       <div className="main-container bg-[#fff] mx-auto px-4 py-8 min-h-[1000px]">
      {/* Header Section */}
      <div className="flex flex-col items-center gap-12 max-w-screen-lg mx-auto pb-5">
        {/* Breadcrumb */}
      <BreadCrumb/>

        {/* Title Section */}
        <div className="text-center flex flex-col gap-6">
          <span className="text-lg   text-[#0d6b70]"> {statsData.type?.name}</span>
          <h1
          className="text-4xl lg:text-[2.7rem] max-sm:text-[1.7rem] text_bold_Bukra text-[#0d6b70] lg:leading-[80px] max-sm:leading-1">
             {statsData.name}
          </h1>
          {/* <p
          className="text-lg lg:text-[1.08rem] text_small_Bukra  text-[#667680] leading-relaxed px-[3.75rem]"
          dangerouslySetInnerHTML={{
            __html: statsData.description || "",
          }}>

          </p> */}
        </div>
      </div>

      <SingleStats statsData={statsData}/>

    </div>
    </>
  );
};

export default Stats;
